import React from "react";
import { useI18n } from "../../providers/I18nProvider";
import { formatDT } from "./reservationUtils";

// Tek rezervasyon satırı/kartı. Aksiyonlar children olarak (actions) gelir.
const ReservationCard = ({ r, showOwner = true, badge = null, actions = null }) => {
  const { t } = useI18n();
  const participants = Array.isArray(r.participants) ? r.participants : [];
  return (
    <div className="reservation-item">
      <div>
        <strong>{r.vehicle_name}</strong>
        {r.vehicle_plate && <span className="reservation-plate">{r.vehicle_plate}</span>}
        {badge && <span className="reservation-role-badge">{badge}</span>}
        <div className="meta">
          {formatDT(r.starts_at)} — {formatDT(r.ends_at)}
        </div>
        {showOwner && (
          <div className="meta">
            {t("fleet.owner")}: {r.owner_name} {r.owner_surname}
          </div>
        )}
        {r.reason && <div className="meta">{r.reason}</div>}
        {participants.length > 0 && (
          <div className="meta">
            {t("fleet.participants")}: {participants.map((p) => `${p.name} ${p.surname}`).join(", ")}
          </div>
        )}
      </div>
      <span className={`status-badge ${r.status}`}>{t(`fleet.statuses.${r.status}`)}</span>
      {actions}
    </div>
  );
};

export default ReservationCard;
